/// <reference path="../_all.ts" />

module solution {
  'use strict';


  export function productByMeasuringTaskFilter() {
     return function(products, measuringTaskProducts) { //items, search
        products = products || [];
        measuringTaskProducts = measuringTaskProducts || [];
        var out = [];
        measuringTaskProducts.forEach(function (productId) {
          products.forEach(function (pObj) {
           if (pObj.Product.Id == productId) {
                out.push(pObj);
            }
          });
        });
        return out;
     }
  }


}